import React from 'react';
import { Link } from 'react-router-dom';


const Navbar = (props)=> {
    
    function handleClicks(event){  
        let t = event.currentTarget;
        t.classList.toggle('burgX');
        let elNavList = document.getElementById('navbar');
        elNavList.classList.toggle('showNav');
    }
    
    return (
        <nav>
            <div id="navContentContainer">
                <div id="navLogoDiv"><span>&lt;&#x270E;&gt;</span></div>
                
                <ul id="navbar">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/javascript">JS Projects</Link></li>
                    <li><Link to="/css">CSS/SASS</Link></li> 
                    <li><Link to="/artwork">Artwork</Link></li>   
                </ul>

                <div className="burger" onClick={handleClicks}>
                    <div className="topB"></div>
                    <div className="midB"></div>
                    <div className="btmB"></div>
                </div>

            </div>


        </nav>
    )
}

export default Navbar;